import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/process/setting";

export default {
    /** 查询业务配置列表（业务端：只看得到当前商户） */
    queryConfigList: (data) => axios.get({url: `${PREFIX_URI}/config/queryList`, data: data}),
    /** 查询业务配置列表（运维端：跨商户，可按商户筛选） */
    queryPlatConfigList: (data) => axios.get({url: `${PREFIX_URI}/plat/config/queryList`, data: data}),
    /** 查询业务配置详情 */
    findConfigById: (id) => axios.get({url: `${PREFIX_URI}/config/findById`, data: {id: id}}),
    /** 保存业务配置 */
    saveConfig: (data) => axios.post({url: `${PREFIX_URI}/config/save`, data: data}),
    /** 删除业务配置 */
    deleteConfig: (id) => axios.del({url: `${PREFIX_URI}/config/delete`, data: {id: id}}),
    /** 启用/停用业务配置 */
    changeConfigStatus: (id, isEnabled) => axios.get({url: `${PREFIX_URI}/config/changeStatus`, data: {id: id, isEnabled: isEnabled}}),

    /** 按业务类型查询字段列表 */
    queryFieldList: (businessType) => axios.get({url: `${PREFIX_URI}/field/queryList`, data: {businessType: businessType}}),
    /** 保存业务字段（先删后插，整体替换） */
    saveFieldList: (data) => axios.post({url: `${PREFIX_URI}/field/saveList`, data: data}),

    /*
     * 业务清单（已对接工作流的业务类型）不在这里 —— 它是系统级字典，
     * 被消息模板/设置/开关、工作流列表、送审中心共用，
     * 已挪到 commonApi.queryBusinessTemplateList（后端 common/businessTemplate/queryList）。
     */

    /** 查询流程定义列表 */
    queryProcessList: (businessType) => axios.get({url: `${PREFIX_URI}/process/queryList`, data: {businessType: businessType}}),
    /** 查询流程定义详情 */
    findProcessById: (id) => axios.get({url: `${PREFIX_URI}/process/findById`, data: {id: id}}),
    /** 保存流程定义 */
    saveProcess: (data) => axios.post({url: `${PREFIX_URI}/process/save`, data: data}),
    /** 删除流程定义 */
    deleteProcess: (id) => axios.del({url: `${PREFIX_URI}/process/delete`, data: {id: id}}),
    /** 发布流程定义 */
    publishProcess: (id) => axios.get({url: `${PREFIX_URI}/process/publish`, data: {id: id}}),
}
